import React                             from "react";
import ReactDOM                          from "react-dom";
import { BrowserRouter, Route, Switch }  from "react-router-dom";

//Image LightBox
import SimpleReactLightbox               from 'simple-react-lightbox'

//Layout default import from components.
import defaultLayout                    from "./components/layouts/main";

//Import wrapping layout
import Layout                           from "./components/app";

//Import all page from components
import aboutUs                          from "./components/pages/aboutus/AboutUs";
import contact                          from "./components/pages/contact/Contact";
import faq                              from "./components/pages/faq/Faq";

import Service1                         from "./components/pages/service1/Service1";
import Service2                         from "./components/pages/service2/Service2";
import Service3                         from "./components/pages/service3/Service3";
import Service4                         from "./components/pages/service4/Service4";

import Product1                         from "./components/pages/product1/Product1";
import Product2                         from "./components/pages/product2/Product2";
import Product3                         from "./components/pages/product3/Product3";
import Product4                         from "./components/pages/product4/Product4";
import Product5                         from "./components/pages/product5/Product5";
import Product6                         from "./components/pages/product6/Product6";
import Product7                         from "./components/pages/product7/Product7";

import AboutUs                          from "./components/pages/aboutus/AboutUs";
import error                            from "./components/pages/404/404";


//Initializations All Css
import './index.css';
import './index.scss';

//Default Warniing Error Hide
console.log = console.warn = console.error = () => {};

/*
* Version : 0.1
* Event : Rendering all content to web.
* Actions: Define all routes and page.
* @return html
* */

class Root extends React.Component{
    render(){
        return(
            <BrowserRouter basename={"/"}>
                    <Switch>
                        <Route exact path='/' component={defaultLayout} />

                        <Layout>
                            <Route path={`${process.env.PUBLIC_URL}/about-us`} component={aboutUs} />

                            <Route path={`${process.env.PUBLIC_URL}/Service1`} component={Service1} />
                            <Route path={`${process.env.PUBLIC_URL}/Service2`} component={Service2} />
                            <Route path={`${process.env.PUBLIC_URL}/Service3`} component={Service3} />
                            <Route path={`${process.env.PUBLIC_URL}/Service4`} component={Service4} />

                            <Route path={`${process.env.PUBLIC_URL}/Product1`} component={Product1} />
                            <Route path={`${process.env.PUBLIC_URL}/Product2`} component={Product2} />
                            <Route path={`${process.env.PUBLIC_URL}/Product3`} component={Product3} />
                            <Route path={`${process.env.PUBLIC_URL}/Product4`} component={Product4} />
                            <Route path={`${process.env.PUBLIC_URL}/Product5`} component={Product5} />
                            <Route path={`${process.env.PUBLIC_URL}/Product6`} component={Product6} />
                            <Route path={`${process.env.PUBLIC_URL}/Product7`} component={Product7} />

                            <Route path={`${process.env.PUBLIC_URL}/AboutUs`} component={AboutUs} />

                            <Route path={`${process.env.PUBLIC_URL}/faq`} component={faq} />
                            <Route path={`${process.env.PUBLIC_URL}/404`} component={error} />
                            <Route path={`${process.env.PUBLIC_URL}/contact`} component={contact} />
                        </Layout>
                    </Switch>
            </BrowserRouter>
        );
    }
}

ReactDOM.render(
    <React.StrictMode>
        <SimpleReactLightbox>
            <Root />
        </SimpleReactLightbox>
    </React.StrictMode>,
    document.getElementById("root")
);
